export const PHONE_DISPLAY = "(209) 304-7682";
export const PHONE_TEL = "tel:+12093047682";
export const ADDRESS = "1351 Shaefer St, Manteca, CA 95336";
export const BLOG_URL = "https://blog.bigbearheatingcooling.com/";
export const GHL_FORM_ID = "w0uY69IkoXgehOr50AGZ";
export const GHL_FORM_SRC = `https://api.leadconnectorhq.com/widget/form/${GHL_FORM_ID}`;
export const GHL_EMBED_SCRIPT = "https://link.msgsndr.com/js/form_embed.js";

export const CITIES = [
  "Manteca", "Stockton", "Tracy", "Modesto", "Turlock",
  "Lodi", "Oakdale", "Ripon", "Lathrop", "Escalon",
  "French Camp", "Salida", "Riverbank", "Ceres", "Hughson",
];

export const SERVED_CITIES = [
  "manteca", "stockton", "tracy", "modesto", "turlock", "lodi",
  "oakdale", "ripon", "lathrop", "escalon", "french camp", "salida",
  "riverbank", "ceres", "hughson", "keyes", "mountain house", "galt",
  "linden", "lockeford", "empire", "del rio", "denair", "waterford",
];

export const SERVED_ZIPS = [
  "95336", "95337", "95330", "95366", "95376", "95377", "95378", "95304",
  "95391", "95202", "95203", "95204", "95205", "95206", "95207", "95209",
  "95210", "95212", "95215", "95219", "95231", "95350", "95351", "95352",
  "95354", "95355", "95356", "95357", "95358", "95368", "95367", "95307",
  "95326", "95328", "95380", "95381", "95382", "95240", "95241", "95242",
  "95361", "95320", "95220", "95227", "95385", "95363", "95323", "95316",
  "95360", "95386", "95313", "95234", "95258", "95319", "95322", "95315",
];

export const REVIEWS = [
  {
    name: "Maria G.",
    town: "Manteca",
    tag: "AC Repair",
    text: "Our AC died on a 104-degree Friday and Big Bear had a tech out the same afternoon. He explained everything, showed me the failed part, and had cold air blowing before dinner. No games, no upsell.",
  },
  {
    name: "Doug & Rita P.",
    town: "Ripon",
    tag: "Furnace Replacement",
    text: "Three companies quoted us, Big Bear was the only one who actually measured the house instead of guessing. The new furnace is quieter and our gas bill dropped. Clean install, spotless cleanup.",
  },
  {
    name: "Sandra T.",
    town: "French Camp",
    tag: "Mobile Home HVAC",
    text: "Finding someone who truly understands mobile home systems is hard. They knew our packaged unit inside and out, fixed the ductwork under the home, and priced it straight. Specialists indeed.",
  },
  {
    name: "Mike H.",
    town: "Stockton",
    tag: "Light Commercial",
    text: "They maintain the rooftop units on our two retail spaces. Preventative visits are on schedule, reports are clear, and when a compressor failed they had us back open the next morning.",
  },
  {
    name: "Elena V.",
    town: "Tracy",
    tag: "After-Hours Emergency",
    text: "Furnace quit at 7 PM on a cold Sunday night. The after-hours line actually got answered, and a tech arrived in about an hour. That is why they are saved in my phone now.",
  },
  {
    name: "Bill K.",
    town: "Oakdale",
    tag: "Seasonal Tune-Up",
    text: "Booked a tune-up before summer. The tech caught a weak capacitor that would have failed in July, and replaced it on the spot for a fair price. Proactive and honest.",
  },
];

export const HOURS = {
  standard: "Mon – Fri | 7:30 AM – 5:00 PM",
  after: "After-Hours 5:00 – 9:00 PM (Mon–Fri) & Full Weekends",
};
